module.exports = __webpack_public_path__ + "static/media/captain.dad0c47f.png";